// extracted by mini-css-extract-plugin
export var measureBox = "_49-0";